import { Stack } from '@mui/material'

import { useController } from '../../../../hooks/useController'
import { Email } from './blocks/Email'
import { Message } from './blocks/Message'
import { MessageTypeSelector } from './blocks/MessageTypeSelector'
import { Sms } from './blocks/Sms'

export function GpsOnlyBody() {
  const {
    data: { messageType },
  } = useController()

  return (
    <Stack direction="column" width="100%" marginTop={4}>
      <MessageTypeSelector />

      {messageType === 'email' ? <Email /> : <Sms />}

      <Message />
    </Stack>
  )
}
